<template>
  <v-app>
    <v-navigation-drawer fixed temporary v-model="sideNav">
      <v-list>
        <v-list-tile
          v-for="item in menuItems"
          :key="item.title"
          :to="item.link">
          <v-list-tile-action>
            <!-- <div v-if="item.title === profile" :> </div> -->
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            {{ item.title }}
            </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          v-if="userIsAuthenticated"
          @click="onLogout">
          <v-list-tile-action>
            <v-tooltip>
            <v-icon slot="activator" style="maxHeight: 8ex">exit_to_app</v-icon>
            <span>Log Out</span>
          </v-tooltip>
          </v-list-tile-action>
          <v-list-tile-content>Logout</v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar height="100ex">
      <v-toolbar-side-icon
        @click.stop="sideNav = !sideNav"
        class="hidden-sm-and-up "></v-toolbar-side-icon>
      <v-toolbar-title>
        <router-link to="/projects" tag="span" style="cursor: pointer"><img src="../static/img/official_icons/logo.png" style="maxHeight: 8ex;"></router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-xs-only">
        <v-btn
          flat
          v-for="item in menuItems"
          :key="item.icon"
          :to="item.link"
          >
          <v-avatar>
            <v-tooltip>
            <div slot="activator"><img :src="item.icon" :alt="item.title" style="maxHeight: 8ex"></div>
            <span>{{item.title}}</span>
          </v-tooltip>
              
          </v-avatar>
          <v-spacer></v-spacer>
          <!-- <v-icon left dark>{{ item.icon }}</v-icon> -->
          <!-- {{ item.title }} -->

        </v-btn>

        <v-spacer style="width: 50px"></v-spacer>
        
        <v-btn
          v-if="userIsAuthenticated"
          flat
          @click="onLogout">
          <v-avatar>
            <v-tooltip>
            <div slot="activator"><img :src="'../static/img/official_icons/signout.png'" :alt="'Logout'" style="maxHeight: 8ex"></div>
            <span>Sign Out</span>
          </v-tooltip>
              
          </v-avatar>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <main>
      <router-view></router-view>
    </main>
  </v-app>
</template>

<script>
  export default {
    data () {
      return {
        sideNav: false,
        profile: 'Profile'
      }
    },
    computed: {
      menuItems () {
        let menuItems = [
          {icon: '../static/img/official_icons/Signup.png', title: 'Sign up', link: '/signup'},
          {icon: '../static/img/official_icons/signin.png', title: 'Sign in', link: '/signin'}
        ]
        if (this.userIsAuthenticated) {
          menuItems = [
            {icon: '../static/img/official_icons/dashboard.png', title: 'Projects', link: '/projects'},
            {icon: '../static/img/official_icons/event2.png', title: 'Calender', link: '/calender'},
            {icon: '../static/img/official_icons/deliverable.png', title: 'Library', link: '/library'},
            {icon: '../static/img/official_icons/profile.png', title: 'Profile', link: '/profile/' + this.$store.getters.user.id}
          ]
        }
        return menuItems
      },
      userIsAuthenticated () {
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
      }
    },
    methods: {
      onLogout () {
        this.$store.dispatch('logout')
        this.$router.push('/')
      }
    }
  }
</script>

<style lang="stylus">
  @import './stylus/main'
</style>



// WEBPACK FOOTER //
// App.vue?660b1524